module.exports = __webpack_public_path__ + "img/15.61433c3f.jpg";